import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  fonts: {
    heading: `'NanumSquareB', sans-serif`,
    body: `'NanumSquareB', sans-serif`,
  },
});

export default theme;